import type { GraphEdgeSettingsId } from '@ipfabric/utils';
import {
  type OptionalArray,
  resolveOptionalArray,
} from '@ipfabric/utils/array/OptionalArray';
import { setEdgeProps } from 'components/Graph/helpers/setEdgeProps';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetVisibleEdgeCommand {
  edgeSettingsId: OptionalArray<GraphEdgeSettingsId>;
  visible: boolean;
}

export const setVisibleEdge: GraphCommandFactory<SetVisibleEdgeCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      for (const edgeSettingsId of resolveOptionalArray(
        command.edgeSettingsId,
      )) {
        setEdgeProps(draft, 'visible', command.visible, edgeSettingsId);
      }
    });
  };
